import React from 'react';
import Section from "./components/Section";
import Typed from "typed.js";
import {IMAGES_DIR} from "../../../Constants/Constants";

class TextCarousel extends React.Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {
		let {strings} = this.props;
		let options = {
			backSpeed: 50,
			typeSpeed: 50,
			backDelay: 1000,
			loop: true,
			strings: strings,
// 			onComplete: ()=>{
// 				this.typed.start();
// //				this.typed.reset();
// 			}
		};
		this.typed = new Typed(this.el, options);
	}

	componentWillUnmount() {
		this.typed.destroy();
	}

	render() {
		return (
			<span ref={(el) => {
				this.el = el;
			}} style={{fontFamily: "monospace", textAlign: "left", align: "left"}}>
			</span>
		);
	}

}

class Intro extends Section {

	constructor(props) {
		super(props);
		//console.log("Intro Constructor", props);
		this.introRef = React.createRef();
	}

	componentDidMount() {
		this.props.updateRef(this.props.title, this.introRef);
	}

	styles = {
		...Section.styles,
		mainContainer: {
			...Section.styles.mainContainer,
			background: "url(" + IMAGES_DIR + "/home.jpg), linear-gradient(to bottom, #311b92, #9575cd)" ,
			backgroundColor: "#311b92",
			backgroundAttachment: 'fixed',
			backgroundSize: "cover",
			padding: "10vmin 10vmin 0 10vmin",
		},
		contentContainer: {
			...Section.styles.contentContainer,
			textAlign: "center",
			padding: "auto",
			minHeight: "100vh",
			display: "flex",
			flexDirection: "column",
			alignContent: "center",
			justifyContent: "space-around",
			alignItems: "center",
			color: "white"
		},
		title: {
			...Section.styles.title,
			fontStyle: "bold",
			fontSize: "12vmin",
			lineHeight: "13vmin",
			color: "#fff"
		},
		subTitle: {
			...Section.styles.subTitle,
			// maxWidth: "90%",
			color: "#ffc107",
			padding: "0.2rem",
			// alignSelf: "left",
			// float: "left",
			backgroundColor: "rgba(0,0,0,0.8)",
			fontSize: "5vmin",
			lineHeight: "6vmin",
			maxWidth: "90vw",
			minWidth: "50vw",
			// height: "2.5rem"
		},
	};

	render() {
		//console.log("Intro Styles:", this.styles);
		return (
			<div style={this.styles.mainContainer} ref={this.introRef}>
				<div style={this.styles.contentContainer}>
					<h1 style={this.styles.title}>Hi, I'm <span style={{whiteSpace: "nowrap"}}>Lalit Jain</span></h1>
					<h2 style={this.styles.subTitle}>
						<TextCarousel strings={this.props.subtitles}/>
					</h2>
					<p> Let's have Tea Sometime...</p>
				</div>
			</div>
		);
	}
}

export default Intro;